export default __webpack_public_path__ + "static/media/results_1st.5c535cd6.jpg";